module.exports = __webpack_public_path__ + "static/promo-text-048e87c49e7de4ef549ae03fcd0d0629.svg";